<h2>Permit Search</h2>
<fieldset>
    <div class="row">
        <div class="col-sm-4 mvd_form-group">
            <label>Permit Number</label>
            <div class="search--input">
                <input class="mvd_form-control autocomplete" id="search" type="text" placeholder="Search by: Number" autocomplete="off" (keyup.enter)="permitSearchClicked()" [(ngModel)]="permitSearchString" />
                <button class="search__icon" title="Search" type="button" (click)="permitSearchClicked()"></button>
            </div>
        </div>
    </div>
</fieldset>

<div class="well__footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="resetSearch();">Reset</button>
    </div>
</div>

<ng-container *ngIf="results && results.length > 0 && results.length < 250">
    <h2>Permit Results ({{ results.length }})</h2>
    <p-table #dt
             class="search__individual"
             [value]="results"
             [rows]="10"
             [paginator]="true"
             [globalFilterFields]="['permitNumber','vehiclePermitTypeId','issueDate','expirationDate']">
        <ng-template pTemplate="caption">
            <div class="row">
                <div class="col-sm-6 col-md-3">
                    <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="4">
                    No records found
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th [pSortableColumn]="'permitNumber'">Permit Number<p-sortIcon [field]="'permitNumber'"></p-sortIcon></th>
                <th [pSortableColumn]="'vehiclePermitTypeId'">Type<p-sortIcon [field]="'vehiclePermitTypeId'"></p-sortIcon></th>
                <th [pSortableColumn]="'issueDate'">Issued<p-sortIcon [field]="'issueDate'"></p-sortIcon></th>
                <th [pSortableColumn]="'expirationDate'">Expiration<p-sortIcon [field]="'expirationDate'"></p-sortIcon></th>
            </tr>
        </ng-template>
        <ng-template  pTemplate="body" let-data>
            <tr [pSelectableRow]="data">
                <td> <a href="javascript:void(0);" (click)="onPermitNumberClicked(data.vehicle);">{{ data.permitNumber }}</a></td>
                <td> {{data.vehiclePermitTypeId | displayValue:permitTypes}}</td>
                <td>{{data.issueDate | shortDate }}</td>
                <td>{{data.expirationDate | shortDate }}</td>
            </tr>
        </ng-template>
</p-table>
</ng-container>

<h2 class="mvd_alert--label" *ngIf="hasSearched && results && results.length == 0">
    No Results
</h2>
<h2 class="mvd_alert--label" *ngIf="results && results.length >= 50">
    Over 50 results were found.
    <br />
    Additional search criteria is required to continue.
</h2>

